"use strict";
/*
 * XInt-3.2: the Eskom booklet's wording for a billed charge.
 *
 * Billing emits its own internal names ("Active Energy - Peak (High Season)"), which are deliberately left
 * alone in the API — the supplier-bill reconciliation reads the season and time-of-use period back out of
 * them to match a supplier's cost to Cue's recovery. Erik asked that what a person reads always be the
 * booklet's wording instead, so the translation happens at the point of display.
 *
 * This mirrors `api/helpers/chargeNameAliases.ts` in lets-cue-api, which does the same translation for the
 * invoice line description and the Xero tracking lookup. The two lists must agree — otherwise the
 * preliminary bill and the tenant's invoice disagree about what a charge is called, which is precisely the
 * confusion this replaced. Change one, change the other.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.bookletChargeName = bookletChargeName;
/** Ignore case, spacing and punctuation, so an em dash vs a hyphen never decides whether a name matches. */
var norm = function (s) {
    return String(s || "")
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
};
/*
 * Only the charges whose wording actually differs appear here. Anything absent already matches the booklet
 * (Network Capacity, Network Demand, Generation Capacity, Ancillary Service, Affordability Subsidy,
 * Administration, Service, and the combined Service and Administration Charge) and passes through unchanged.
 */
var BOOKLET_NAME = {
    "Active Energy - Flat Rate": "Energy Charge",
    "Active Energy - Peak (High Season)": "Active Energy Charge — High season, Peak",
    "Active Energy - Standard (High Season)": "Active Energy Charge — High season, Standard",
    "Active Energy - Off-Peak (High Season)": "Active Energy Charge — High season, Off-peak",
    "Active Energy - Peak (Low Season)": "Active Energy Charge — Low season, Peak",
    "Active Energy - Standard (Low Season)": "Active Energy Charge — Low season, Standard",
    "Active Energy - Off-Peak (Low Season)": "Active Energy Charge — Low season, Off-peak",
    "Legacy Charges": "Legacy Charge",
    "Electrification & Rural Network Subsidy": "Electrification & Rural Network Subsidy Charge",
};
var BY_NORM = new Map(Object.entries(BOOKLET_NAME).map(function (_a) {
    var billed = _a[0], booklet = _a[1];
    return [norm(billed), booklet];
}));
/**
 * The name to show a person for a billed charge. A charge with no correction is returned unchanged, so an
 * unfamiliar name is displayed as billed rather than disappearing.
 */
function bookletChargeName(billedName) {
    var _a;
    var raw = String(billedName !== null && billedName !== void 0 ? billedName : "").trim();
    return (_a = BY_NORM.get(norm(raw))) !== null && _a !== void 0 ? _a : raw;
}
